import { MatLegacyDialog as MatDialog }from '@angular/material/legacy-dialog';
import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, StepControlType, WizardServiceLocator } from '@sdbn/appclient';
import { ContextChange } from '@sdbn/appclient';
import { ConfirmDialogComponent, ConfirmDialogData } from 'src/app/shared/confirm-dialog/confirm.dialog.component';
import { LogContainer } from 'src/tmc-common/model/log-container.model';
import { TerminalContextConstants } from 'src/tmc-common/model/terminal-context-constants';
import { ProcessSelectionActionType, ProcessSelectOption } from '../widgets/terminal/process-selection/process-selection.model';

export class ProcessSelectionController extends AbstractStepController {

    onContextChange(contextChange: ContextChange) {
        if (contextChange.key === 'selectedProcessOption') {
          this.handleSelectedProcessOption(this.dashboardContext.getContextValue('selectedProcessOption'));
        }
    }

    onRegisterToDashboardContext() {
    }

    private handleSelectedProcessOption(selectedProcessOption: ProcessSelectOption) {
        this.wizardComponent.stopInactivityMonitoring();
        if (selectedProcessOption.actionType === ProcessSelectionActionType.PROCESS_FLOW) {
          this.wizardComponent.handoverToFlow(selectedProcessOption.processFlowKey);
        } else if (selectedProcessOption.actionType === ProcessSelectionActionType.PROCESS_STEP) {
          this.wizardComponent.next(selectedProcessOption.processStepKey);
        } else {
          console.error('Missconfigured processselectionoption. neither flow or step defined', selectedProcessOption);
        }
    }

    public handleFlow(): FlowStepHandleResult {

        this.dashboardContext.setContextValue('dashboardConfiguration', this.wizardComponent.currentStep.dashboardConfiguration);

        this.wizardComponent.startInactivityMonitoring();
        const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
        logContainer.addLog('registration type selection started');

        const result = new FlowStepHandleResult();
        result.type = HandleResultType.DASHBOARD;
        return result;
    }

    private cancel() {
        const matDialog = WizardServiceLocator.injector.get(MatDialog);
        const dialogData: ConfirmDialogData = {
            titleKey: 'tmc-yard.widgets.registration-terminal.cancel-dialog.title',
            messageKey: 'tmc-yard.widgets.registration-terminal.cancel-dialog.message',
            confirm: () => {
                this.wizardComponent.stopInactivityMonitoring();
                this.wizardComponent.restartWizard();
            }
        };
        matDialog.open(ConfirmDialogComponent, {
            data: dialogData
        });
    }

    getControls(): StepControl[] {
        const controls = new Array<StepControl>();

        const spacer = new StepControl();
        spacer.type = StepControlType.SPACER_GROW;
        controls.push(spacer);

        const cancelControl = new StepControl();
        cancelControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.button.cancel';
        cancelControl.type = StepControlType.BUTTON_STROKED;
        cancelControl.iconBeforeCss = 'fa-thin fa-xmark';
        cancelControl.controlAction = this.cancel.bind(this);
        controls.push(cancelControl);

        return controls;
    }
}
